import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IFile } from 'src/sync';
import { ShareService } from '../../services/share.service';
import { SHARE_DETAILS_OPEN_STATE } from '../../models';

@Component({
  selector: 'app-dialog-share-details',
  templateUrl: './dialog-share-details.component.html',
  styleUrls: ['./dialog-share-details.component.scss']
})
export class DialogShareDetailsComponent implements OnChanges {

  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() showDialog!: boolean;
  @Input() selected: IFile[] = [];
  @Input() public openState: number = -1;
  public shareData: any;
  public verifyEmailMessage: string = 'Your account must be verified in order to invite new users to this shared folder.';
  loading: boolean = false;
  shareDetailsOpenState = SHARE_DETAILS_OPEN_STATE;
  constructor(
    public shareService: ShareService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selected']) {
      this.getShareDetails();
    }
  }

  public async onStateChange(state) {
    if (state == SHARE_DETAILS_OPEN_STATE.CLOSE_STATE) return;
    if (state == SHARE_DETAILS_OPEN_STATE.MEMBER_LIST) {
      const share = await this.shareService.getShare(this.shareData.shareId);
      this.shareData = share;
      this.setVerifyEmailMessage();
    }
    this.openState = state;
  }
  async getShareDetails() {
    this.loading = true;
    const share = this.selected;
    const webpath = Array.isArray(share) ? share[0] : share;
    const shareId = webpath.shareId || webpath.share_id;
    this.shareData = await this.shareService.getShare(shareId);
    this.setVerifyEmailMessage();
    this.loading = false;

  }
  closeDialog = (flag: boolean) => {
    this.showDialog = flag;
    setTimeout(() => {
      this.showDialogChange.next(flag);
    }, 50);
  }

  setVerifyEmailMessage = ()=> {
    if(this.shareData.isOwner){
      this.verifyEmailMessage ='Your account must be verified in order to add new users to this shared folder.'
    }else if(this.shareData.isInvite){
      this.verifyEmailMessage = 'Your account must be verified in order to invite new users to this shared folder.';
    }
  }
}
